export default __webpack_public_path__ + "static/media/whats-ojo-house.0f0aa422.png";